import { render, staticRenderFns } from "./getfree.vue?vue&type=template&id=28f9861e&scoped=true"
import script from "./getfree.vue?vue&type=script&lang=js"
export * from "./getfree.vue?vue&type=script&lang=js"
import style0 from "./getfree.vue?vue&type=style&index=0&id=28f9861e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f9861e",
  null
  
)

export default component.exports